import { Link } from "@/lib/router-compat";
import { MapPin, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getLocationBySlug } from "@/data/locations";

const areas = [
  { name: "Blaine, MN", description: "Trusted contractor for roof replacement and repairs.", slug: "blaine" },
  { name: "Coon Rapids, MN", description: "Siding, windows, and storm damage restoration.", slug: "coon-rapids" },
  { name: "Eden Prairie, MN", description: "Expert roofing and exterior services.", slug: "eden-prairie" },
  { name: "Plymouth, MN", description: "Professional roofing, siding, and more.", slug: "plymouth" },
  { name: "Woodbury, MN", description: "Reliable roofing and exterior craftsmanship.", slug: "woodbury" },
  { name: "St. Paul, MN", description: "Serving the capital city with quality exteriors.", slug: "st-paul" },
];

export const ServiceAreas = () => {
  return (
    <section className="relative py-16 lg:py-24 bg-primary overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-white mb-4">
            SERVICE AREAS
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto">
            We proudly serve homeowners throughout Minnesota, from the Twin Cities metro to projects a few hours out.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {areas.map((area) => {
            const loc = getLocationBySlug(area.slug);
            const image = loc?.image;
            return (
              <Link key={area.name} to={`/locations/${area.slug}`} className="block">
                <div className="backdrop-blur rounded-xl border border-white/20 hover:border-secondary/60 shadow-[0_4px_20px_rgba(0,0,0,0.4)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.5)] transition-all group cursor-pointer h-full overflow-hidden bg-white/5">
                  {image && (
                    <div className="aspect-video overflow-hidden">
                      <img
                        src={image}
                        alt={area.name}
                        loading="lazy"
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                  )}
                  <div className="p-6">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-lg bg-secondary/20 flex items-center justify-center group-hover:bg-secondary/30 transition-colors">
                        <MapPin className="w-5 h-5 text-secondary" aria-hidden="true" />
                      </div>
                      <h3 className="font-heading font-semibold text-white">{area.name}</h3>
                    </div>
                    <p className="text-white/70 text-base">{area.description}</p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center">
          <Link to="/locations">
            <Button className="bg-secondary hover:bg-secondary/90 text-secondary-foreground font-semibold font-subheading">
              View All Service Areas <ArrowRight className="w-4 h-4 ml-2" aria-hidden="true" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
